export function isValidDateFormat(dateString) {
    console.log(dateString)
    const dateRegex = /^\d{4}\/\d{2}\/\d{2}$/;
    return dateRegex.test(dateString);
}